import FormGroup from '../FormGroup/FormGroup';
import PropTypes from 'prop-types';
import { useField } from 'react-aria';
import { charLengths, relativeLengths, getWidthClass } from 'client/utils/constants/GDS/js/widths';

const Select = ({ labelAsTitle, width, onChange, children, value, ...props }) => {
    const { labelProps, fieldProps, descriptionProps, errorMessageProps } = useField(props);

    return (
        <FormGroup
            labelProps={labelProps}
            label={props.label}
            labelAsTitle={labelAsTitle}
            description={props.description}
            descriptionProps={descriptionProps}
            errorMessage={props.errorMessage}
            errorMessageProps={errorMessageProps}
            data-testid={props['data-testid'] ? props['data-testid'] : null}
        >
            <select
                {...fieldProps}
                value={value}
                name={props?.name}
                className={['govuk-select', getWidthClass(width)].join(' ')}
                data-testid={props['data-testid'] ? props['data-testid'] + '.select' : null}
                onChange={onChange}
            >
                {children}
            </select>
        </FormGroup>
    );
};

Select.propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.string,
    labelAsTitle: PropTypes.bool,
    errorMessage: PropTypes.string, // This prop is used by the react-aria library to create the error message and accessible error attributes for the control
    description: PropTypes.string, // This prop is used by the react-aria library to create the description and accessible description attributes for the control
    children: PropTypes.array,
    width: PropTypes.oneOf([...relativeLengths, ...charLengths]),
    'data-testid': PropTypes.string,
    onChange: PropTypes.func
};

Select.defaultProps = {
    labelAsTitle: false,
    width: 'full'
};

export default Select;
